import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import Layout from './components/Layout';
import Login from './pages/Login';
import Today from './pages/Today';
import Archive from './pages/Archive';
import Newsletters from './pages/Newsletters';
import Profile from './pages/Profile';
import AdminSources from './pages/admin/Sources';
import AdminQueries from './pages/admin/Queries';
import AdminRuns from './pages/admin/Runs';

export default function App() {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-teal/20 border-t-teal" />
      </div>
    );
  }

  if (!user) {
    if (location.pathname === '/login') return <Login />;
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Today />} />
        <Route path="/archive" element={<Archive />} />
        <Route path="/newsletters" element={<Newsletters />} />
        <Route path="/profile" element={<Profile />} />
        {user.role === 'admin' && (
          <>
            <Route path="/admin" element={<Navigate to="/admin/sources" replace />} />
            <Route path="/admin/sources" element={<AdminSources />} />
            <Route path="/admin/queries" element={<AdminQueries />} />
            <Route path="/admin/runs" element={<AdminRuns />} />
          </>
        )}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
